import Vue from 'vue'
import App from './App.vue'
import ScrollMagic from 'scrollmagic'
import 'animation.gsap'
import 'debug.addIndicators'
import VueScrollTo from 'vue-scrollto'
import objectFitPolyfill from 'objectFitPolyfill'

Vue.config.productionTip = false

Vue.use(VueScrollTo, {
  container: "body",
  duration: 800,
  easing: "ease",
  offset: 0,
  force: true,
  cancelable: true,
  onStart: false,
  onDone: false,
  onCancel: false,
  x: false,
  y: true
})

Vue.use(objectFitPolyfill)

Vue.directive('scroll', {
  inserted: function (el, binding) {
    let f = function (evt) {
      if (binding.value(evt, el)) {
        window.removeEventListener('scroll', f)
      }
    }
    window.addEventListener('scroll', f)
  }
})

Vue.prototype.$sm = ScrollMagic

new Vue({
  render: h => h(App)
}).$mount('#app')
